import {Dispatch, SetStateAction} from 'react'
import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from '../../lib'

import {doPROJECT_SET, doREQUEST_ERROR, doREQUEST_COMPLETE} from '../state'
import {getToken} from './token_fetcher'
import {IProjectScheduleConfig, ProjectScheduleFrequency, ProjectScheduleReference} from '../../shared/db'

export const REQUEST_PROJECT_DUPLICATE = 'REQUEST_PROJECT_DUPLICATE'
export const doREQUEST_PROJECT_DUPLICATE = createDoRequestAction(REQUEST_PROJECT_DUPLICATE)

export const requestProjectDuplicateActionCreators = {
  doREQUEST_PROJECT_DUPLICATE,
}

interface Payload {
  payload: {
    projectId: string
    projectName: string
    workspaceId?: string
    requestId: string
    scheduleConfig?: Partial<IProjectScheduleConfig>
  }
  setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>
}

export function* requestProjectDuplicate({payload, setRequestResult}: Payload): SagaIterator {
  debug('saga*requestProjectDuplicate')
  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectName: v.string().exist(),
        projectId: v.string().uuid().exist(),
        workspaceId: v.string().uuid().optional(),
        scheduleConfig: v
          .object({
            frequency: v
              .string()
              .allow(...Object.values(ProjectScheduleFrequency), null)
              .exist(),
            reference: v
              .string()
              .allow(...Object.values(ProjectScheduleReference), null)
              .exist(),
            absoluteReferenceYymmdd: v.number().integer().min(100000).max(999999).allow(null).exist(),
          })
          .optional(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_DUPLICATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {projectName, projectId, workspaceId, scheduleConfig} = payload
  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/project-duplicate`,
    accessToken,
    data: {
      projectName,
      projectId,
      workspaceId,
      scheduleConfig,
    },
  })

  // handle error
  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_DUPLICATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/project-duplicate',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(doPROJECT_SET(result.payload))

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_DUPLICATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* projectDuplicateSaga() {
  yield takeEvery(REQUEST_PROJECT_DUPLICATE as any, requestProjectDuplicate)
}
